export default "__VITE_ASSET__88c38929__"